import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgKr48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "South Korea",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.39 9 2.07-3.14zm.78.52 2.07-3.14zM6 10l2-3.09zm.09.12-.29-.19 2.07-3.12.29.19zm-.78-.52L5 9.41l2.1-3.12.29.19zm-.77-.52-.29-.19 2.07-3.11.29.22zm11.27 7.52 2.07-3.11zm.77.51L18.67 14zm.79.53 2.07-3.11zm.15.09-.29-.19 2.07-3.12.29.19zm-.79-.52-.29-.21 2.07-3.12.3.19zM16 16.7l-.29-.19 2.07-3.12.29.19zm.33-2 2.6 1.73z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m16.43 14.55-.19.29 2.59 1.73.2-.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43630",
  d: "M14.06 14.83a3.74 3.74 0 1 0-5.21-.93 3.75 3.75 0 0 0 5.21.93"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004fbb",
  d: "M8.81 9.68a1.87 1.87 0 1 0 3.11 2.08A1.87 1.87 0 1 1 15 13.84a3.75 3.75 0 1 1-6.19-4.16"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.47 17.64-2.08-3.11zm.77-.53L5.17 14zM8 16.6l-2-3.11zm-1.68 1.13-2.07-3.1.29-.19 2.07 3.12zm.78-.52L5 14.1l.29-.19L7.39 17zm.78-.51L5.8 13.58l.29-.19 2.07 3.12zm10-6.7-2.07-3.09zm.79-.53L16.6 6.38zm.78-.47-2.07-3.14zm-1.71 1.12L15.67 7l.33-.19 2 3.12zm.77-.52-2.07-3.12.29-.19 2.08 3.12zm.79-.52L17.23 6l.29-.18 2.07 3.11zM5.81 15.83l.79-.52zm10.52-7 .91-.61zM18 7.69l.79-.51z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.91 16-.19-.29.79-.51.19.29zm10.52-7-.19-.29.91-.61.19.29zm1.68-1.13-.19-.29.78-.58.19.29z"
}));

export { SvgKr48Rounded as default };
//# sourceMappingURL=Kr48Rounded.js.map
